import {
  RESPONSE_TRIALS_SITES,
  FAILURE_TRIALS_SITES,
  FAILURE_KOL_MAPPING,
  RESPONSE_KOL_MAPPING,
  FAILURE_COLLABORATOR_NETWORK,
  RESPONSE_COLLABORATOR_NETWORK,
  RESPONSE_ORGANISATIONS,
  FAILURE_ORGANISATIONS,
  RESPONSE_DIRECT_AFFILIATION_SEARCH,
  FAILURE_DIRECT_AFFILIATION_SEARCH,
  FAILURE_LOCATION,
  RESPONSE_LOCATION,
  FAILURE_LOCATION_TABLE,
  RESPONSE_LOCATION_TABLE,
  PERSON_SIMILARITY_RESULT_FAILURE,
  PERSON_SIMILARITY_RESULT_RESPONSE,
  RESPONSE_TRIALS_PHASES,
  FAILURE_TRIALS_PHASES,
  RESPONSE_KEYWORD_GRANTS,
  FAILURE_KEYWORD_GRANTS,
  RELATED_CONCEPTS_CHANGE,
  RELATED_CONCEPTS_SYNONYMS_CHANGE,
  PEER_REVIEWER_RESULT_RESPONSE,
  PEER_REVIEWER_RESULT_FAILURE,
  RESPONSE_MLD_MAIN_EXPERTS_SEARCH,
  FAILURE_MLD_MAIN_EXPERTS_SEARCH,
  MLD_AFFILIATIONS_RESPONSE,
  MLD_AFFILIATIONS_FAILURE,
  RESPONSE_SUMMARY_LOCATION_MLD,
  FAILURE_SUMMARY_LOCATION_MLD,
  RESPONSE_MLD_TRIALS,
  FAILURE_MLD_TRIALS,
  RESPONSE_MLD_MEDICAL_BODIES,
  FAILURE_MLD_MEDICAL_BODIES,
  RESPONSE_MLD_TRIALS_COUNTRY,
  FAILURE_MLD_TRIALS_COUNTRY,
  RESPONSE_MLD_TRIALS_EXPERTS,
  FAILURE_MLD_TRIALS_EXPERTS,
  RESPONSE_MLD_TRIALS_INSTITUTE,
  FAILURE_MLD_TRIALS_INSTITUTE,
  MLD_NETWORK_RESPONSE,
  MLD_NETWORK_FAILURE,
  RESPONSE_MLD_TWEET_USERS,
  FAILURE_MLD_TWEET_USERS,
  RESPONSE_ERN_REF_NETWORK,
  FAILURE_ERN_REF_NETWORK,
  RESPONSE_MLD_SUMMARY,
  FAILURE_MLD_SUMMARY,
  RESPONSE_WAS_MAIN_EXPERTS_SEARCH,
  FAILURE_WAS_MAIN_EXPERTS_SEARCH,
  WAS_AFFILIATIONS_RESPONSE,
  WAS_AFFILIATIONS_FAILURE,
  RESPONSE_SUMMARY_LOCATION_WAS,
  FAILURE_SUMMARY_LOCATION_WAS,
  RESPONSE_WAS_TRIALS,
  FAILURE_WAS_TRIALS,
  RESPONSE_WAS_TRIALS_COUNTRY,
  FAILURE_WAS_TRIALS_COUNTRY,
  RESPONSE_WAS_TRIALS_EXPERTS,
  FAILURE_WAS_TRIALS_EXPERTS,
  RESPONSE_WAS_TRIALS_INSTITUTE,
  FAILURE_WAS_TRIALS_INSTITUTE,
  RESPONSE_WAS_CONFS,
  FAILURE_WAS_CONFS,
  RESPONSE_WAS_MEDICAL_BODIES,
  FAILURE_WAS_MEDICAL_BODIES,
  WAS_NETWORK_RESPONSE,
  WAS_NETWORK_FAILURE,
  RESPONSE_WAS_SUMMARY,
  FAILURE_WAS_SUMMARY,
  RESPONSE_DASHBOARD,
  RESPONSE_RARE_DISEASE_TWEETS,
  RESPONSE_RARE_DISEASE,
  RESPONSE_RARE_DISEASE_MORE_TWEETS,
  RARE_DISEASE_CLICKS,
  RESPONSE_ZOGENIX_MAIN_EXPERTS_SEARCH,
  FAILURE_ZOGENIX_MAIN_EXPERTS_SEARCH,
  // RESPONSE_ZOGENIX_TRIALS,
  // FAILURE_ZOGENIX_TRIALS,
  // RESPONSE_ZOGENIX_TRIALS_COUNTRY,
  // FAILURE_ZOGENIX_TRIALS_COUNTRY,
  // RESPONSE_ZOGENIX_TRIALS_EXPERTS,
  // FAILURE_ZOGENIX_TRIALS_EXPERTS,
  // RESPONSE_ZOGENIX_TRIALS_INSTITUTE,
  // FAILURE_ZOGENIX_TRIALS_INSTITUTE,
  RESPONSE_ZOGENIX_SUMMARY,
  FAILURE_ZOGENIX_SUMMARY,
  ISNS_CLICKS,
  RESPONSE_ISNS,
  RESPONSE_NEWBORN_MAIN_EXPERTS_SEARCH,
  FAILURE_NEWBORN_MAIN_EXPERTS_SEARCH,
  NEWBORN_AFFILIATIONS_RESPONSE,
  NEWBORN_AFFILIATIONS_FAILURE,
  RESPONSE_SUMMARY_LOCATION_NEWBORN,
  FAILURE_SUMMARY_LOCATION_NEWBORN,
  RESPONSE_MLD_HOME_SEARCH,
  FAILURE_MLD_HOME_SEARCH,

  APP_EXPERTS_SEARCH_RESPONSE,
  APP_EXPERTS_SEARCH_FAILURE,
  APP_AFFILIATIONS_RESPONSE,
  APP_AFFILIATIONS_FAILURE,
  APP_LOCATIONS_SUMMARY_RESPONSE,
  APP_LOCATIONS_SUMMARY_FAILURE,
  APP_TRIALS_RESPONSE,
  APP_TRIALS_FAILURE,
  APP_CONGRESS_RESPONSE,
  APP_CONGRESS_FAILURE,
  APP_MEDICAL_BODIES_RESPONSE,
  APP_MEDICAL_BODIES_FAILURE,
  APP_NETWORK_RESPONSE,
  APP_NETWORK_FAILURE,
  APP_SOCIAL_MEDIA_RESPONSE,
  APP_SOCIAL_MEDIA_FAILURE,

} from "../../actions/types";

export const _validActions = [
  RESPONSE_ZOGENIX_MAIN_EXPERTS_SEARCH,
  FAILURE_ZOGENIX_MAIN_EXPERTS_SEARCH,
  // RESPONSE_ZOGENIX_TRIALS,
  // FAILURE_ZOGENIX_TRIALS,
  // RESPONSE_ZOGENIX_TRIALS_COUNTRY,
  // FAILURE_ZOGENIX_TRIALS_COUNTRY,
  // RESPONSE_ZOGENIX_TRIALS_EXPERTS,
  // FAILURE_ZOGENIX_TRIALS_EXPERTS,
  // RESPONSE_ZOGENIX_TRIALS_INSTITUTE,
  // FAILURE_ZOGENIX_TRIALS_INSTITUTE,
  
  RESPONSE_ZOGENIX_SUMMARY,
  FAILURE_ZOGENIX_SUMMARY,
  RESPONSE_TRIALS_SITES,
  FAILURE_TRIALS_SITES,
  FAILURE_KOL_MAPPING,
  RESPONSE_KOL_MAPPING,
  FAILURE_COLLABORATOR_NETWORK,
  RESPONSE_COLLABORATOR_NETWORK,
  RESPONSE_ORGANISATIONS,
  FAILURE_ORGANISATIONS,
  RESPONSE_DIRECT_AFFILIATION_SEARCH,
  FAILURE_DIRECT_AFFILIATION_SEARCH,
  FAILURE_LOCATION,
  RESPONSE_LOCATION,
  FAILURE_LOCATION_TABLE,
  RESPONSE_LOCATION_TABLE,
  PERSON_SIMILARITY_RESULT_FAILURE,
  PERSON_SIMILARITY_RESULT_RESPONSE,
  RESPONSE_TRIALS_PHASES,
  FAILURE_TRIALS_PHASES,
  RESPONSE_KEYWORD_GRANTS,
  FAILURE_KEYWORD_GRANTS,
  RELATED_CONCEPTS_CHANGE,
  RELATED_CONCEPTS_SYNONYMS_CHANGE,
  PEER_REVIEWER_RESULT_RESPONSE,
  PEER_REVIEWER_RESULT_FAILURE,
  RESPONSE_MLD_MAIN_EXPERTS_SEARCH,
  FAILURE_MLD_MAIN_EXPERTS_SEARCH,
  MLD_AFFILIATIONS_RESPONSE,
  MLD_AFFILIATIONS_FAILURE,
  RESPONSE_SUMMARY_LOCATION_MLD,
  FAILURE_SUMMARY_LOCATION_MLD,
  FAILURE_MLD_TRIALS,
  RESPONSE_MLD_TRIALS,
  FAILURE_MLD_TRIALS,
  FAILURE_MLD_MEDICAL_BODIES,
  RESPONSE_MLD_MEDICAL_BODIES,
  RESPONSE_MLD_TRIALS_COUNTRY,
  FAILURE_MLD_TRIALS_COUNTRY,
  RESPONSE_MLD_TRIALS_EXPERTS,
  FAILURE_MLD_TRIALS_EXPERTS,
  RESPONSE_MLD_TRIALS_INSTITUTE,
  FAILURE_MLD_TRIALS_INSTITUTE,
  MLD_NETWORK_RESPONSE,
  MLD_NETWORK_FAILURE,
  RESPONSE_MLD_TWEET_USERS,
  FAILURE_MLD_TWEET_USERS,
  RESPONSE_ERN_REF_NETWORK,
  FAILURE_ERN_REF_NETWORK,
  RESPONSE_MLD_SUMMARY,
  FAILURE_MLD_SUMMARY,
  RESPONSE_WAS_MAIN_EXPERTS_SEARCH,
  FAILURE_WAS_MAIN_EXPERTS_SEARCH,
  WAS_AFFILIATIONS_RESPONSE,
  WAS_AFFILIATIONS_FAILURE,
  RESPONSE_SUMMARY_LOCATION_WAS,
  FAILURE_SUMMARY_LOCATION_WAS,
  RESPONSE_WAS_TRIALS,
  FAILURE_WAS_TRIALS,
  RESPONSE_WAS_TRIALS_COUNTRY,
  FAILURE_WAS_TRIALS_COUNTRY,
  RESPONSE_WAS_TRIALS_EXPERTS,
  FAILURE_WAS_TRIALS_EXPERTS,
  RESPONSE_WAS_TRIALS_INSTITUTE,
  FAILURE_WAS_TRIALS_INSTITUTE,
  RESPONSE_WAS_CONFS,
  FAILURE_WAS_CONFS,
  RESPONSE_WAS_MEDICAL_BODIES,
  FAILURE_WAS_MEDICAL_BODIES,
  WAS_NETWORK_RESPONSE,
  WAS_NETWORK_FAILURE,
  RESPONSE_WAS_SUMMARY,
  FAILURE_WAS_SUMMARY,
  RESPONSE_DASHBOARD,
  RESPONSE_RARE_DISEASE_TWEETS,
  RESPONSE_RARE_DISEASE,
  RESPONSE_RARE_DISEASE_MORE_TWEETS,
  RARE_DISEASE_CLICKS,
  ISNS_CLICKS,
  RESPONSE_ISNS,
  RESPONSE_NEWBORN_MAIN_EXPERTS_SEARCH,
  FAILURE_NEWBORN_MAIN_EXPERTS_SEARCH,
  NEWBORN_AFFILIATIONS_RESPONSE,
  NEWBORN_AFFILIATIONS_FAILURE,
  RESPONSE_SUMMARY_LOCATION_NEWBORN,
  FAILURE_SUMMARY_LOCATION_NEWBORN,
  RESPONSE_MLD_HOME_SEARCH,
  FAILURE_MLD_HOME_SEARCH,

  APP_EXPERTS_SEARCH_RESPONSE,
  APP_EXPERTS_SEARCH_FAILURE,
  APP_AFFILIATIONS_RESPONSE,
  APP_AFFILIATIONS_FAILURE,
  APP_LOCATIONS_SUMMARY_RESPONSE,
  APP_LOCATIONS_SUMMARY_FAILURE,
  APP_TRIALS_RESPONSE,
  APP_TRIALS_FAILURE,
  APP_CONGRESS_RESPONSE,
  APP_CONGRESS_FAILURE,
  APP_MEDICAL_BODIES_RESPONSE,
  APP_MEDICAL_BODIES_FAILURE,
  APP_NETWORK_RESPONSE,
  APP_NETWORK_FAILURE,
  APP_SOCIAL_MEDIA_RESPONSE,
  APP_SOCIAL_MEDIA_FAILURE
];
